import { memo } from "react";
import { Route, Navigate } from "react-router-dom";

import Login from "../pages/loginpages/signin";
import Forgot from "../pages/loginpages/forgot";
import Password from "../pages/loginpages/password";
import Otpverfication from "../pages/loginpages/otpverfication";

// import Dashboard from "../src/pages/dashboard";

import Protected from "./Protected";
import { isEmpty } from "../actions/common";
import NotFound from "../pages/NotFound";
import AuthLayout from "../layouts/AuthLayout";

export const PublicRoutes = (Auth, Token) => {

  // const Auths = Auth && isEmpty(Token) ? true : false;
  // const Auths_sign = Token && Auth ? false : true;

  return (
    <>

      <Route path="/" element={<AuthLayout isSignedIn={Auth} />}>

        <Route path="/" element={<Login />} />
        <Route path="/signin" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/Changepassword" element={<Password />} />
        <Route path="/otpverfication" element={<Otpverfication />} />
        <Route exact path="/notfound" element={<NotFound />} />

      </Route>
      {/* <Route exact path="/" element={<Login />}/>
        <Route path="/forgot" element={<Forgot />}/>
        <Route path="/password" element={<Password />}/>
        <Route path="/otpverfication" element={<Otpverfication />}/> */}
    </>
  );
};
